import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["variant", "className", "validationState", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as s } from "react/jsx-runtime";
import o from "react";
import { c as l } from "../../../clsx-OuTLNxxd.js";
const c = "InputText-module_input__-ZEIH",
  d = "InputText-module_input-default__TJ08R",
  _ = "InputText-module_input-transparent__VxkKd",
  m = "InputText-module_input-black__FAmgi",
  f = "InputText-module_state-invalid__br-5g",
  x = "InputText-module_input-big__YG6ec",
  t = {
    input: c,
    inputDefault: d,
    inputTransparent: _,
    inputBlack: m,
    stateInvalid: f,
    inputBig: x
  },
  I = (i, u) => {
    const {
        variant: n = "default",
        className: e,
        validationState: a = void 0,
        size: p = "default"
      } = i,
      r = _objectWithoutProperties(i, _excluded);
    return /* @__PURE__ */s("input", _objectSpread(_objectSpread({
      ref: u
    }, r), {}, {
      "aria-invalid": a == "error",
      className: l(e, t.input, {
        [t.inputDefault]: n == "default",
        [t.inputBig]: p == "big",
        [t.inputTransparent]: n == "transparent",
        [t.inputBlack]: n == "black",
        [t.stateInvalid]: a == "error"
      })
    }));
  },
  B = /* @__PURE__ */o.forwardRef(I);
export { B as InputText };